import { useQuery } from "@tanstack/vue-query";
import QueryKeys from "@/vue-query/QueryKeys";
import { useProjectApi } from "../api/useProjectApi";

export function useProjectFirewallSuspectedOffendersCountQuery(
  projectId: Ref<string>
) {
  const client = useProjectApi();

  const enabled = computed(() => !!projectId.value);

  return useQuery(
    [QueryKeys.FirewallSuspectedOffendersCount, projectId],
    () => client.getFirewallSuspectedOffendersCount(projectId.value),
    { enabled: enabled, refetchOnWindowFocus: false, staleTime: Infinity }
  );
}
